class FAQs {

  elements = {};

  constructor(wrapper) {
    this.loadElements(wrapper);
    this.collapseAll();
    this.toggleAnswer(0);
    this.setEventListeners();
    this.animate();
  }

  loadElements(wrapper) {
    this.elements.wrapper = wrapper;
    this.elements.questions = wrapper.find('.faqs__question');
    this.elements.answers = wrapper.find('.faqs__answer');
  }

  collapseAll(exceptIndex = null) {
    this.elements.questions.each(
      (index) => {
        if (index === exceptIndex) {
          return;
        }

        this.elements.questions.eq(index).attr('aria-checked', 'false');
        this.elements.answers.eq(index).prop('hidden', true);
      }
    );
  }

  toggleAnswer(index) {
    const checked = this.elements.questions.eq(index).attr('aria-checked') === 'true';

    this.elements.questions.eq(index).attr('aria-checked', checked ? 'false' : 'true');
    this.elements.answers.eq(index).prop('hidden', checked);
  }

  animate() {
    this.elements.answers.each(
      (index) => {
        const answer = this.elements.answers.eq(index);

        if (answer.prop('hidden')) {
          answer.slideUp(200);
        } else {
          answer.slideDown(200);
        }
      }
    );
  }

  setEventListeners() {
    this.elements.questions.on(
      'click',
      (event) => {
        const index = this.elements.questions.index(event.currentTarget);

        this.collapseAll(index);
        this.toggleAnswer(index);
        this.animate();
      }
    );
  }
}

jQuery(document).ready(
  () => {
    const wrappers = jQuery('.faqs__wrapper');
    wrappers.each(
      (index) => {
        new FAQs(wrappers.eq(index));
      }
    );
  }
);
